export const messages = {
  en: {
    shopVisit: {
      queryCondition: 'Query Conditions',
      visitId: 'Visit ID',
      visitUser: 'Visitor',
      visitIp: 'Visit IP',
      visitTime: 'Visit Time',
      remark: 'Remark',
      shopVisit: 'Shop Visits',
      visitIdPlaceholder: 'Please enter visit ID',
      visitUserPlaceholder: 'Please enter visitor',
      visitIpPlaceholder: 'Please enter visit IP'
    }
  },
  zh: {
    shopVisit: {
      queryCondition: '查询条件',
      visitId: '访问编号',
      visitUser: '访问用户',
      visitIp: '访问IP',
      visitTime: '访问时间',
      remark: '备注',
      shopVisit: '店铺访问',
      visitIdPlaceholder: '请输入访问编号',
      visitUserPlaceholder: '请输入访问用户',
      visitIpPlaceholder: '请输入访问IP'
    }
  }
}